module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "idFrmPan",
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "border": "0px solid blue",
      "height": "100%"
    },
    attrs: {
      "id": "idFrmPan"
    }
  }, [_c('div', {
    staticStyle: {
      "flex": "0 0 auto",
      "width": "100%",
      "height": "50px",
      "border": "0px solid red"
    }
  }, [_c('div', {
    staticClass: "SiftPanel",
    staticStyle: {
      "border": "0px solid #bbbbbb"
    }
  }, [_c('cselect', {
    staticStyle: {
      "position": "relative",
      "height": "30px",
      "min-width": "120px",
      "z-index": "999",
      "margin-left": "20px"
    },
    attrs: {
      "defv": _vm.findImgType,
      "ctrl": _vm.ctrlImgType,
      "csData": _vm.dataImgType
    },
    model: {
      value: (_vm.findImgType),
      callback: function($$v) {
        _vm.findImgType = $$v
      },
      expression: "findImgType"
    }
  }), _vm._v(" "), _c('cselect', {
    staticStyle: {
      "position": "relative",
      "height": "30px",
      "min-width": "100px",
      "z-index": "999"
    },
    attrs: {
      "defv": _vm.findPasterType,
      "ctrl": _vm.ctrlPasterType,
      "csData": _vm.dataPasterType
    },
    model: {
      value: (_vm.findPasterType),
      callback: function($$v) {
        _vm.findPasterType = $$v
      },
      expression: "findPasterType"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "Capt DIVNoSelect",
    staticStyle: {
      "flex": "0 0 auto",
      "margin-top": "0px",
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm.getLangText("素材名称")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.findSourceName),
      expression: "findSourceName"
    }],
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.findSourceName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.findSourceName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('check', {
    staticStyle: {
      "height": "30px",
      "margin-right": "10px",
      "margin-left": "20px"
    },
    attrs: {
      "size": 18,
      "grpName": _vm.cckName,
      "val": 2,
      "capt": _vm.getLangText('私有'),
      "checked": true
    }
  }), _vm._v(" "), _c('check', {
    staticStyle: {
      "height": "30px",
      "margin-right": "20px"
    },
    attrs: {
      "size": 18,
      "grpName": _vm.cckName,
      "val": 1,
      "capt": _vm.getLangText('共享'),
      "checked": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "NButton DIVNoSelect",
    staticStyle: {
      "width": "32px",
      "height": "32px",
      "background": "url(../static/images/op_fin.png)",
      "margin-top": "-1px",
      "margin-left": "10px"
    },
    on: {
      "click": _vm.onSourceListClick
    }
  })], 1)]), _vm._v(" "), _c('div', {
    ref: "idListPan",
    staticStyle: {
      "flex": "1 0 auto",
      "width": "100%",
      "height": "100%",
      "border": "0px solid blue",
      "display": "flex",
      "flex-direction": "row",
      "flex-wrap": "wrap",
      "overflow-y": "auto"
    },
    attrs: {
      "id": "idListPan"
    }
  }, _vm._l((_vm.imgData), function(curItem, index) {
    return _c('div', {
      staticStyle: {
        "flex": "0 0 auto",
        "width": "155px",
        "height": "177px",
        "border": "1px solid #bbbbbb",
        "margin-left": "40px",
        "margin-top": "20px",
        "position": "relative",
        "z-index": "900"
      },
      attrs: {
        "index": index
      },
      on: {
        "click": function($event) {
          return _vm.onSourceClick(curItem);
        }
      }
    }, [(curItem.siCustId > 0) ? _c('div', {
      staticStyle: {
        "z-index": "990",
        "position": "absolute",
        "width": "50px",
        "height": "50px",
        "background": "url(../static/images/publish3.png)",
        "background-size": "100% 100%"
      }
    }) : _vm._e(), _vm._v(" "), (curItem.siCustId == 0) ? _c('div', {
      staticStyle: {
        "z-index": "990",
        "position": "absolute",
        "width": "50px",
        "height": "50px",
        "background": "url(../static/images/publish2.png)",
        "background-size": "100% 100%"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "DIVNoSelect",
      staticStyle: {
        "z-index": "991",
        "position": "absolute",
        "transform": "rotate(-45deg) scale(0.7)",
        "left": "-16px",
        "top": "8px",
        "width": "70px",
        "height": "20px",
        "line-height": "20px",
        "border": "0px solid red",
        "color": "#ffffff",
        "text-align": "center",
        "font-size": "14px"
      }
    }, [_vm._v(_vm._s(curItem.publicText))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "left",
        "width": "153px",
        "height": "22px",
        "line-height": "22px",
        "text-align": "center",
        "border-bottom": "1px solid #bbbbbb",
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(curItem.siNameEng))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "left",
        "width": "153px",
        "height": "153px",
        "background": "#bbbbbb",
        "border": "0px solid #bbbbbb"
      }
    }, [_c('ImgThum', {
      key: _vm.freshKey2 + index,
      staticStyle: {
        "float": "left",
        "border": "0px solid red",
        "width": "100%",
        "height": "100%",
        "cursor": "pointer"
      },
      attrs: {
        "item": curItem,
        "thW": 144,
        "thH": 144
      }
    })], 1)])
  }), 0), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "0 0 auto",
      "width": "100%",
      "height": "30px",
      "border": "0px solid red"
    }
  }, [_c('cpage', {
    key: _vm.keyFind,
    staticStyle: {
      "margin-left": "0px"
    },
    attrs: {
      "ctrl": _vm.ctrlPage
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-95af958e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/aiphoto/TemplaSetSource.vue
// module id = 804
// module chunks = 1